import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FormData, Errors } from "./SignInViewModel";
import "./SignInStyle.css";

interface State {
  formData: FormData;
  errors: Errors;
  showAGB: boolean;
  showDSGVO: boolean;
  showUse: boolean;
  passwordVisible: boolean;
  passwordVisibleConfirmed: boolean;
}

interface Actions {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: () => void;
  setShowAGB: (value: boolean) => void;
  setShowDSGVO: (value: boolean) => void;
  setShowUse: (value: boolean) => void;
  togglePasswordVisibility: () => void;
  togglePasswordVisibilityConfirmed: () => void;
}

interface Props {
  state: State;
  actions: Actions;
}

const SignInView: React.FC<Props> = ({ state, actions }) => {
  return (
    <div className="ja-signin-container">
      <div className="ja-signin-header">
        <h2>Registrieren</h2>
        <p>Erstellen Sie Ihr Junior Alarm Konto</p>
      </div>

      <div className="ja-signin-form">
        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Ort</label>
          <input
            type="text"
            name="location"
            className="ja-login-inputBox"
            placeholder="Ort eingeben"
            value={state.formData.location}
            onChange={actions.handleChange}
          />
          {state.errors.location && (
            <span className="ja-login-errorLabel">{state.errors.location}</span>
          )}
        </div>

        <div className="ja-login-inputContainer">
          <label className="ja-login-label">E-Mail Adresse</label>
          <input
            type="email"
            name="email"
            className="ja-login-inputBox"
            placeholder="name@beispiel.de"
            value={state.formData.email}
            onChange={actions.handleChange}
          />
          {state.errors.email && (
            <span className="ja-login-errorLabel">{state.errors.email}</span>
          )}
        </div>

        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Passwort</label>
          <div className="ja-login-passwordContainer">
            <input
              className="ja-login-inputBox"
              placeholder="Passwort eingeben"
              name="password"
              type={state.passwordVisible ? "text" : "password"}
              value={state.formData.password}
              onChange={actions.handleChange}
            />
            <FontAwesomeIcon
              icon={state.passwordVisible ? faEyeSlash : faEye}
              onClick={actions.togglePasswordVisibility}
              className="ja-login-passwordIcon"
            />
          </div>
          {state.errors.password && (
            <span className="ja-login-errorLabel">{state.errors.password}</span>
          )}
        </div>

        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Passwort bestätigen</label>
          <div className="ja-login-passwordContainer">
            <input
              className="ja-login-inputBox"
              placeholder="Passwort wiederholen"
              name="confirmPassword"
              type={state.passwordVisibleConfirmed ? "text" : "password"}
              value={state.formData.confirmPassword}
              onChange={actions.handleChange}
            />
            <FontAwesomeIcon
              icon={state.passwordVisibleConfirmed ? faEyeSlash : faEye}
              onClick={actions.togglePasswordVisibilityConfirmed}
              className="ja-login-passwordIcon"
            />
          </div>
          {state.errors.confirmPassword && (
            <span className="ja-login-errorLabel">{state.errors.confirmPassword}</span>
          )}
        </div>

        {/* Checkboxen */}
        <div className="ja-signin-checkboxGroup">
          <label className="ja-signin-checkboxItem">
            <input
              type="checkbox"
              checked={state.showAGB}
              onChange={(e) => actions.setShowAGB(e.target.checked)}
            />
            <span>
              Ich akzeptiere die{" "}
              <a
                href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/datenschutzerklaerung"
                target="_blank"
                rel="noopener noreferrer"
              >
                AGBs
              </a>
            </span>
          </label>

          <label className="ja-signin-checkboxItem">
            <input
              type="checkbox"
              checked={state.showDSGVO}
              onChange={(e) => actions.setShowDSGVO(e.target.checked)}
            />
            <span>
              Ich akzeptiere die{" "}
              <a
                href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/agb"
                target="_blank"
                rel="noopener noreferrer"
              >
                Datenschutzerklärung
              </a>
            </span>
          </label>

          <label className="ja-signin-checkboxItem">
            <input
              type="checkbox"
              checked={state.showUse}
              onChange={(e) => actions.setShowUse(e.target.checked)}
            />
            <span>
              Ich akzeptiere die{" "}
              <a
                href="https://mbsoftwaresolutions.de/produkte/rescueplattform/junioralarm/nutzungsbedingungen"
                target="_blank"
                rel="noopener noreferrer"
              >
                Nutzungsbedingungen
              </a>
            </span>
          </label>
        </div>

        {/* Absende-Button */}
        <button
          type="button"
          className="ja-login-primaryButton"
          onClick={actions.handleSubmit}
          disabled={!(state.showAGB && state.showDSGVO && state.showUse)}
        >
          Konto erstellen
        </button>
      </div>
    </div>
  );
};

export default SignInView;